// extracted by mini-css-extract-plugin
export default {"root":"FlowAssetView_root__xEWYf"};